/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Soil = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/Soil"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="SVG">
      <path
        fill="#4BA279"
        d="M5.117 2.238c1.768-.585 3.486-.05 4.713 1.167 1.005.996 1.547 2.32 1.387 3.729q.107.181.215.375c.301.542.605 1.152.883 1.818a20 20 0 0 1 1.287-3.308c-.148-.652-.045-1.332.267-1.949.487-.966 1.405-1.623 2.578-1.622.703.93.724 2.052.236 3.019-.303.6-.771 1.08-1.363 1.357-.205.405-.473.983-.742 1.703-.53 1.421-1.057 3.378-1.121 5.636l-.007.456h-1.9l-.01-.443c-.1-2.201-.92-4.226-1.772-5.757l-.06-.105c-1.29.043-2.492-.486-3.415-1.401-1.227-1.217-1.766-2.922-1.176-4.675"
      />
      <path
        fill="#F90"
        d="M22 12.577C22 17.781 17.747 22 12.5 22S3 17.781 3 12.577c0 0 3.8-1.257 9.5-1.257 5.676 0 9.468 1.246 9.5 1.257"
      />
      <path
        fill="#000"
        fillOpacity={0.2}
        d="M22 12.577C22 17.781 17.747 22 12.5 22S3 17.781 3 12.577c0 0 3.8-1.257 9.5-1.257 5.676 0 9.468 1.246 9.5 1.257"
      />
      <path
        fill="#000"
        fillOpacity={0.5}
        d="M12.5 17.446c.525 0 .95.422.95.942s-.425.942-.95.942a.947.947 0 0 1-.95-.942c0-.52.426-.942.95-.942m-3.8-2.828c.525 0 .95.422.95.943s-.425.942-.95.942a.946.946 0 0 1-.95-.942c0-.52.425-.943.95-.943m7.6 0c.525 0 .95.422.95.943s-.425.942-.95.942a.947.947 0 0 1-.95-.942c0-.52.425-.943.95-.943"
      />
    </g>
  </svg>
);

export const SoilIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'soil-icon'}
      icon={Soil}
      {...props}
      size={size}
    />
  );
};
